import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as campaignProposalActions from 'agency/redux/modules/campaignProposal'

import EditingNavBar from 'agency/digital_renderer/components/EditingNavBar'
import RealhubFooter from 'components/RealhubFooter'
import ToggleableSection from 'agency/digital_renderer/components/ToggleableSection'

import AgencyProperties from './components/AgencyProperties'
import Agents from './components/Agents'
import CampaignQuotes from './components/CampaignQuotes'
import Commission from './components/Commission'
import CustomSections from './components/CustomSections'
import Download from './components/Download'
import Footer from './components/Footer'
import Header from './components/Header'
import PriceRecommendation from './components/PriceRecommendation'
import PropertyDetails from './components/PropertyDetails'
import Timeline from './components/Timeline'
import Welcome from './components/Welcome'
import styles from './styles.scss'

class RealhubPremium extends Component {
  state = {}

  render(){
    const {
      agents,
      artwork,
      brand,
      campaign,
      campaignProposal,
      campaignSaleMethod,
      contacts,
      editing,
      images,
      dashboardSettings,
      updateCampaignProposal,
    } = this.props

    return (
      <main className={styles.root}>
        <EditingNavBar
          campaignProposal={campaignProposal}
          dataSource={campaignProposal}
          dataSourceType="CampaignProposal"
          editing={editing}
          redirect={dashboardSettings.redirect}
          callbacks={{ updateCampaignProposal }}
        />

        <Header
          artwork={artwork}
          brand={brand}
          campaign={campaign}
          campaignProposal={campaignProposal}
          contacts={contacts}
          images={images}
        />

        <ToggleableSection sectionId="welcome">
          <Welcome campaignProposal={campaignProposal} />
        </ToggleableSection>

        <ToggleableSection sectionId="property-details">
          <PropertyDetails brand={brand} campaign={campaign} campaignSaleMethod={campaignSaleMethod} />
        </ToggleableSection>

        <PriceRecommendation campaign={campaign} campaignProposal={campaignProposal} />

        <ToggleableSection sectionId="agency-properties">
          <AgencyProperties brand={brand} campaign={campaign} />
        </ToggleableSection>

        <Commission campaignProposal={campaignProposal} />

        <ToggleableSection sectionId="agents">
          <Agents agents={agents} campaign={campaign} />
        </ToggleableSection>

        <CustomSections campaignProposal={campaignProposal} editing={editing} />

        <CampaignQuotes brand={brand} campaignProposal={campaignProposal} />

        <Timeline campaign={campaign} />

        <Download artwork={artwork} brand={brand} campaignProposal={campaignProposal} images={images} />

        <ToggleableSection sectionId="footer">
          <Footer agents={agents} campaign={campaign} />
        </ToggleableSection>

        <RealhubFooter link="http://www.realhub.com.au/proposals" />
      </main>
    )
  }
}

RealhubPremium.propTypes = {
  agents: PropTypes.object.isRequired,
  artwork: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  campaignSaleMethod: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  dashboardSettings: PropTypes.object,
  editing: PropTypes.bool,
  images: PropTypes.object.isRequired,
  updateCampaignProposal: PropTypes.func.isRequired,
}

function mapStateToProps(state){
  const { agents, contacts, images } = state.entities

  return {
    dashboardSettings: window.dashboardSettings || {},
    agents,
    contacts,
    images,
  }
}

const mapDispatchToProps = {
  updateCampaignProposal: campaignProposalActions.updateCampaignProposal,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RealhubPremium)
